import React, { useEffect, useState } from 'react';
import Pagination from 'react-bootstrap/Pagination';
import { useLocation } from 'react-router-dom';

const PaginationComponet = ({ currentPage, totalCount, limit, onPageChange }) => {
  console.log({currentPage, totalCount, limit, onPageChange})
  const location = useLocation();
  const [page, setPage] = useState(currentPage || 1);
  const queryPage = Number(new URLSearchParams(location.search).get('page')) || 1;

  useEffect(() => {
    setPage(queryPage);
  }, [queryPage]);

  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
    onPageChange(pageNumber);
  };

  const totalPages = Math.ceil(totalCount / limit);
  if (totalPages <= 1) return null;

  const renderPageItems = () => {
    const items = [];
    const delta = 2; // Show 2 pages on each side of current page
    const range = [];
    const rangeWithDots = [];

    // Calculate range
    for (let i = Math.max(2, page - delta); i <= Math.min(totalPages - 1, page + delta); i++) {
      range.push(i);
    }

    if (page - delta > 2) {
      rangeWithDots.push(1, '...');
    } else {
      rangeWithDots.push(1);
    }

    rangeWithDots.push(...range);

    if (page + delta < totalPages - 1) {
      rangeWithDots.push('...', totalPages);
    } else if (totalPages > 1) {
      rangeWithDots.push(totalPages);
    }

    // Remove duplicates
    const uniqueItems = [...new Set(rangeWithDots)];

    return uniqueItems.map((item, index) => {
      if (item === '...') {
        return <Pagination.Ellipsis key={`ellipsis-${index}`} />;
      }
      return (
        <Pagination.Item
          key={item}
          active={item === page}
          onClick={() => handlePageChange(item)}
        >
          {item}
        </Pagination.Item>
      );
    });
  };

  return (
    <Pagination>
      <Pagination.First
        onClick={() => handlePageChange(1)}
        disabled={page === 1}
      />
      <Pagination.Prev
        onClick={() => handlePageChange(page - 1)}
        disabled={page === 1}
      />
      {renderPageItems()}
      <Pagination.Next
        onClick={() => handlePageChange(page + 1)}
        disabled={page === totalPages}
      />
      <Pagination.Last
        onClick={() => handlePageChange(totalPages)}
        disabled={page === totalPages}
      />
    </Pagination>
  );
};

export default PaginationComponet;